<div class="component-data-dictionary">

  <div class="component-data-dictionary__header">
    <div class="component-data-dictionary__header-text">
      <h1>Data Dictionary</h1>
      <p>A shared reference of key data terms, definitions, and field-level metadata used across enterprise systems.</p>
    </div>
    <div class="component-data-dictionary__search-wrap">
      <input
        class="component-data-dictionary__search"
        type="text"
        placeholder="Search terms, owners, or systems…"
        [(ngModel)]="searchQuery"
      />
    </div>
  </div>

  <div class="component-data-dictionary__table-wrap">
    <table class="component-data-dictionary__table">
      <thead>
        <tr>
          <th>Term</th>
          <th>Definition</th>
          <th>Owner</th>
          <th>Stakeholders</th>
          <th>Sample Data</th>
          <th>Field / Code</th>
          <th>System</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let term of filteredTerms">
          <td class="term-name">{{ term.term }}</td>
          <td class="term-definition">{{ term.definition }}</td>
          <td>{{ term.owner }}</td>
          <td class="term-stakeholders">{{ term.stakeholders }}</td>
          <td><code>{{ term.sampleData }}</code></td>
          <td><code>{{ term.code }}</code></td>
          <td>
            <span class="system-tag" [ngClass]="systemClass(term.system)">
              {{ term.system }}
            </span>
          </td>
        </tr>
        <tr *ngIf="filteredTerms.length === 0">
          <td colspan="7" class="no-results">No terms match your search.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="component-data-dictionary__footer">
    <span>{{ filteredTerms.length }} term{{ filteredTerms.length === 1 ? '' : 's' }}</span>
  </div>

</div>
